import { useTranslation } from "react-i18next";
import KiloNewton from "../../../../../components/Math/Units/Metric/KiloNewton";
import { NumberFormatText } from "../../../../../components/NumberFormatText";
import { RowBody } from "../../../../../components/RowValue/RowBody";
import ToolTip, { IconType } from "../../../../../components/ToolTip";

function CharakteristischeSchwingbreite({ charakteristischeSchwingbreite }) {
  const { t } = useTranslation("translation");
  const R_k_delta_sigma_Formula = `\\displaystyle R_{k, \\Delta\\sigma} = \\frac{{\\normalsize \\Delta\\sigma}_{\\tiny R,k}}{A_{s}}`;

  return (
    <RowBody
      titleValue={<p>{t("inner.fatigue.characteristicAmplitude")}</p>}
      formulaValue={
        <ToolTip
          id={"R_k_delta_sigma_Formula"}
          type={IconType.FORMULA}
          formula={R_k_delta_sigma_Formula}
        />
      }
      indicesValue={
        <span>
          R<sub>k,Δσ</sub>
        </span>
      }
      inputValue={
        <span className="input">
          <NumberFormatText value={charakteristischeSchwingbreite} decimalScale={0} />
        </span>
      }
      unitValue={<KiloNewton />}
    />
  );
}

export default CharakteristischeSchwingbreite;
